import { z } from 'zod';
import { CuidSchema } from './crm.schemas.js';
import { CHAT_PAGE_SIZE, MAX_CHANNEL_MEMBERS, MAX_MESSAGE_CHARS } from './chat.js';

/**
 * مخططات الشات.
 */

export const CreateChannelSchema = z.object({
  name: z.string().trim().min(2, 'اسم القناة مطلوب.').max(80),
  topic: z.string().trim().max(300).nullable().optional(),
  /** الخاصة يراها أعضاؤها وحدهم؛ والعامة يقرؤها كل من في الشركة. */
  isPrivate: z.boolean().default(false),
  memberIds: z.array(CuidSchema).max(MAX_CHANNEL_MEMBERS).default([]),
});
export type CreateChannelInput = z.infer<typeof CreateChannelSchema>;

export const UpdateChannelSchema = z.object({
  name: z.string().trim().min(2).max(80).optional(),
  topic: z.string().trim().max(300).nullable().optional(),
});
export type UpdateChannelInput = z.infer<typeof UpdateChannelSchema>;

export const OpenDirectSchema = z.object({
  userId: CuidSchema,
});
export type OpenDirectInput = z.infer<typeof OpenDirectSchema>;

/**
 * صفحة الرسائل.
 *
 * التصفّح بالمعرّف لا بالرقم: رسائل تصل أثناء التصفّح تُزيح الترقيم فيتكرّر
 * ما قُرئ ويسقط ما لم يُقرأ. و`before` نقطةٌ ثابتة لا تتحرّك.
 */
export const MessagesQuerySchema = z.object({
  before: CuidSchema.optional(),
  limit: z.coerce.number().int().min(1).max(CHAT_PAGE_SIZE).default(CHAT_PAGE_SIZE),
});
export type MessagesQuery = z.infer<typeof MessagesQuerySchema>;

export const SendMessageSchema = z.object({
  body: z
    .string()
    .trim()
    .min(1, 'اكتب رسالة.')
    .max(MAX_MESSAGE_CHARS, `الرسالة أطول من ${MAX_MESSAGE_CHARS} حرفًا.`),
});
export type SendMessageInput = z.infer<typeof SendMessageSchema>;

export const AddMembersSchema = z.object({
  userIds: z.array(CuidSchema).min(1, 'اختر عضوًا على الأقل.').max(MAX_CHANNEL_MEMBERS),
});
export type AddMembersInput = z.infer<typeof AddMembersSchema>;
